module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-127.af28c9c2.jpg";